import { render, staticRenderFns } from "./VoiceCallLogViewInfo.vue?vue&type=template&id=19990d2c&"
import script from "./VoiceCallLogViewInfo.vue?vue&type=script&lang=js&"
export * from "./VoiceCallLogViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports